module.exports = __webpack_public_path__ + "img/logo_letter.86afdc1f.png";